<template>
  
  <div class="change-history" v-if="histories && histories.length > 0">
    <div v-for="(change, index) in histories" :key="index">
      <div
        v-if="currentUser && change.author"
        class="change-item"
        :class="{
          'my-change': change.author.user_id === currentUser.user_id,
          'other-change': change.author.user_id !== currentUser.user_id,
          'unread': !change.read_at
        }"
      >
        <div class="change-content">
          <div class="change-header">{{ task_name(change) }}</div>
          
          <div class="user-info mt-4">
            <span class="user-name">{{ change.author.firstname }} {{ change.author.lastname }}</span>
            <span class="user-email">{{ change.author.email }}</span>
          </div>

          <div class="change-details">
            <p class="timestamp">{{ formatDate(change.created_at) }}</p>

            <div v-if="change.type === 'FILE_CREATED'" class="file-change">
              <p>
                Fil:
                <a :href="`/files/${change.file_id}`" target="_blank">{{ change.file.name }}</a>
              </p>
            </div>

            <div v-else-if="change.type === 'COMMENT_CREATED'" class="comment-change">
              <p>
                {{ change.message }}
              </p>
            </div>

            <div v-else-if="change.type === 'TODO_STATUS_UPDATED'" class="status-update">
              <p>
                Status för ärendet uppdaterat till {{ $t('TODO.STATUSES.' + (change.new_status || '').toUpperCase()) }}
              </p>
            </div>

            <div v-else-if="change.type === 'TASK_STATUS_UPDATED'" class="status-update">
              <p>
                Status för åtgärd "{{ change.task.name }}" uppdaterat till {{ $t('TODO.STATUSES.' + (change.new_status || '').toUpperCase()) }}
              </p>
            </div>
          </div>
        </div>
      </div>


    </div>

    <m-row>
      <m-col lg="6">
        <memlist-image-dropzone-upload
          class="mt-2"
          v-model="dropzone_image"
          @uploaded="on_file_uploaded"
        />
      </m-col>
      <m-col lg="6">
        <m-row>
          <m-col lg="8">
            <memlist-textarea
              id="text_chatmessage"
              name="text_chatmessage"
              layout="vertical"
              v-model="input_text"
              size="lg"
              rows="4"
            />
          </m-col>
          <m-col lg="4">
            <memlist-button
              class="mb-8 mt-2"
              :size="'large'"
              @click="send_message_clicked"
            >
              Skicka
            </memlist-button>
          </m-col>
        </m-row>
      </m-col>
    </m-row>
  </div>

  
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  name: 'TodoHistoryList',
  emits: ['created'],
  props: {
    histories: {
      type: Array,
      required: true,
    },
    task: {
      type: Object,
      required: true
    }
  },
  watch: {
    histories: {
      deep: true,
      handler(val) {
        
      },
      immediate: true
    },
    currentCompanyId() {
      
    }
  },

  data() {
    return {
      dropzone_image: null,
      input_text: null
    }
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'currentUser']),
  },

  methods: {

    task_name(change) {
      return change?.task?.name || '';
    },
    
    async send_message_clicked() {
      if (!this.input_task || this.input_task.length === 0) {
        return;
      }

      try {
        const res = await axios.post(`/todo_task/comment/${this.task.todo_task_id}`, {
          comment: this.input_text,
          is_top: true,
        });

        if (res.status === 201) {
          this.$emit('created', res.data);
          this.input_task = null;
        }
      }
      catch (err) {
        console.error('send_message_clicked error', err);
      }
    },
    on_file_uploaded(file) {

    },
    formatDate(datetime) {
      return new Date(datetime).toLocaleString(); // Customize formatting as needed
    },
  },
};
</script>


<style scoped>

.change-header {
  padding: 6px;
  background-color: #e6e9eb;
  border: 1px solid #c6c6d1;
  border-radius: 8px;
}

.header-slot {
  padding: 12px;
  border-radius: 8px;
  background-color: #f5f5f5;
  min-width: 512px;
  margin-top: 8px;
}

.change-history {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Message wrapper */
.change-item {
  display: flex;
  width: 100%;
}

/* My messages */
.my-change {
  justify-content: flex-end;
}

/* Others' messages */
.other-change {
  justify-content: flex-start;
}

/* Shared message content styling */
.change-content {
  background-color: #cee6ff; /* Default to blue for my messages */
  color: black;
  border-radius: 8px;
  padding: 10px;
  max-width: 80%;
  word-wrap: break-word;
  min-width: 600px;
}

/* Override background for others */
.other-change .change-content {
  background-color: #f0f0f0;
  color: black;
}

/* Unread icon */
.unread .new-indicator {
  margin-left: 5px;
  color: #007bff;
  font-size: 1em;
}

/* Inside content */
.comment-change {
  font-style: italic;
  color: inherit;
  margin-top: 5px;
  font-size: 1em;
}

.user-info {
  font-size: 0.85em;
  color: #555;
}

.timestamp {
  font-size: 0.75em;
  color: #aaa;
  margin-bottom: 10px;
}

.file-change {
  margin-top: 5px;
  font-size: 1em;
}

.file-change a {
  color: #007bff;
  text-decoration: none;
}

.file-change a:hover {
  text-decoration: underline;
}
</style>
